import react from "react";
import VFB1 from "../assets/VFB1.png";
import VFB2 from "../assets/VFB2.png";
import VFB3 from "../assets/VFB3.png";
import VFB4 from "../assets/VFB4.png";
import VFB5 from "../assets/VFB5.png";
import VFB6 from "../assets/VFB6.png";


export default function FeaturesSection() {
  return (
    <div className="w-full bg-black sm:py-12 md:py-16 py-20 sm:px-8 md:px-6 lg:px-8 xl:px-20 px-24">

      {/* GRID CONTAINER */}
      <div className=" gap-y-12 mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 grid-cols-3">

        {/* CARD 1 */}
       {/* CARD 1 */}
<div className="sm:border-b sm:text-center sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFB1} alt="Feature Icon 1" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] uppercase leading-tight">
      Unlock Authentic Fan Perspectives
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed sm:mb-3">
      Professional cameras show the action. Fans show the feeling. Vupop gives broadcasters a simple way to explore match day fan content captured by real supporters and sports creators. This adds emotion and depth to sports broadcasting and digital coverage.
    </p>
  </div>
</div>

{/* CARD 2 */}
<div className="sm:border-b sm:text-center sm:border-[#2B2E33] sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFB2} alt="Feature Icon 2" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] uppercase leading-tight">
      Support Live and Near-Live Workflows
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed sm:mb-3">
      Timing matters in broadcasting. The window to include fan content is small. Vupop brings fan clips into one place so broadcast teams can find and use them fast. Fans give permission through Vupop's terms, which removes manual work and makes the process simpler for production teams.
    </p>
  </div>
</div>

{/* CARD 3 */}
<div className="sm:border-b sm:text-center sm:border-r-0 md:border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFB3} alt="Feature Icon 3" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] uppercase leading-tight">
      Grow As a Sports Creator
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed sm:mb-3">
      Some fans become sports creators without even trying — a powerful celebration or a funny reaction can reach thousands online. Vupop helps turn those authentic moments into higher viewer attention, stronger social response, better story building, and extended highlight value, keeping audiences connected from the first whistle to the final highlight.
    </p>
  </div>
</div>

{/* CARD 4 */}
<div className="sm:border-b sm:text-center sm:border-[#2B2E33] sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFB4} alt="Feature Icon 4" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] uppercase leading-tight">
      Solve Key Production Pain Points
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed sm:mb-3">
      Vupop helps broadcasters overcome common challenges with fan content by making it easy to discover content in one place, collaborate with real supporters and creators, speed up live or near-live coverage, reward fans fairly, and add emotion, bringing fans into the story without slowing down production.
    </p>
  </div>
</div>

{/* CARD 5 */}
<div className="sm:border-b sm:text-center sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFB5} alt="Feature Icon 5" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] uppercase leading-tight">
      Add Value, Don't Replace Coverage
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed sm:mb-3">
      Fan content does not replace professional footage. It complements it. Official cameras show the pitch. Fan content shows the crowd. Together, they deliver richer sports broadcasting. Vupop respects the role of broadcasters and works to support existing production workflows and editorial standards.
    </p>
  </div>
</div>

{/* CARD 6 */}
<div className="sm:text-center p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFB6} alt="Feature Icon 6" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] uppercase leading-tight">
      Protect Authenticity in an AI Media Landscape
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed sm:mb-3">
      With synthetic media increasing, authenticity has become a premium asset in sports. Fan content confirms what is real, what happened and how people felt. Vupop helps broadcasters access real fan voices that keep trust and credibility high.
    </p>
  </div>
</div>

      </div>
    </div>
  );
}